import Distribution from './DistributionContainer';

export default Distribution